export const formatTime = (time: string) => {
  return time.length > 4 ? time : '0' + time;
};

export const addDays = (days: number): Date => {
  const today = new Date(Date.now())
  today.setDate(today.getDate() + days++);
  return today;
}